module.exports = __webpack_public_path__ + "img/building-1.dbfdb7e8.svg";